// usage:   {process.env.GATSBY_SANITY_WATCH_MODE && (<GridHelper />)}

import React from "react"
import styled from "styled-components"
import { Margin, Grid } from "@components/atoms"
import { range } from "lodash-es"

const GridHelper = ({ className }: { className: string }) => {
  const [visible, setVisible] = React.useState(false)
  return (
    <>
      <GridHelperButton {...{ className }} onClick={() => setVisible(!visible)}>
        👾
      </GridHelperButton>
      <StyledMargin {...{ visible }}>
        <StyledGrid>
          {range(0, 12).map((_, i) => (
            <GridColumn key={`view_column_${i}`} hideMobile={i > 5}>
              {i + 1}
            </GridColumn>
          ))}
        </StyledGrid>
      </StyledMargin>
    </>
  )
}

const StyledMargin = styled(props => <Margin {...props} />)<{
  visible: boolean
}>`
  display: ${props => (props.visible ? "block" : "none")};
  position: fixed;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  outline: 5px solid white;
  box-sizing: border-box;
  pointer-events: none;
`

const StyledGrid = styled(props => <Grid {...props} />)`
  padding: 0;
`

const GridColumn = styled.div<{ hideMobile: boolean }>`
  @media only screen and (max-width: 767px) {
    display: ${props => (props.hideMobile ? "none" : "block")};
  }
  height: 100vh;
  grid-column: span 1;
  background-color: rgba(0, 0, 0, 0.05);
  text-align: center;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
`

const GridHelperButton = styled.button`
  position: absolute;
  left: 0px;
  appearance: none;
  background: transparent;
  outline: transparent;
  border: transparent;
  color: white;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-size: 12px;
`

export default GridHelper
